// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface HotelBedIconSignature {
  Element: SVGSVGElement;
}

export const HotelBedIcon: TOC<HotelBedIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 13.496C20.483 13.681 20.96 13.876 21.426 14.095C21.776 14.261 22 14.613 22 15V22H20V20H4V22H2V15C2 14.613 2.224 14.261 2.574 14.095C3.04 13.876 3.518 13.681 4 13.496V6H6V8H18V6H20V13.496ZM18 12.836V10H13V12.065C14.692 12.139 16.375 12.393 18 12.836ZM6 10H11V12.065C9.308 12.139 7.625 12.394 6 12.836V10ZM20 15.646C15.003 13.489 8.997 13.489 4 15.646V18H20V15.646Z"/>
</svg>
</template>;